import { React, useEffect, useState } from "react";
import CustomInput from "../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  createCategory,
  getAProductCategory,
  resetState,
  updateAProductCategory,
} from "../features/pcategory/pcategorySlice";
import Dropzone from "react-dropzone";
import ImageCropperModal from "../components/ImageCropperModal";
import { JEWELLERY_TYPE_OPTIONS } from "../constants/jewelleryType";
import { resolveMediaUrl } from "../utils/mediaUrl";

let schema = yup.object().shape({
  category_name: yup.string().required("Category Name is Required"),
  category_image: yup.mixed().required("Category Image is Required"),
  jewellery_type: yup
    .string()
    .oneOf(JEWELLERY_TYPE_OPTIONS.map((o) => o.value))
    .required("Jewellery type is required"),
});


const Addcat = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const getPCatId = location.pathname.split("/")[3];
  const navigate = useNavigate();
  const categoryName = useSelector((state) => state.pCategory.categoryName);
  const categoryImage = useSelector((state) => state.pCategory.categoryImage);
  const jewelleryType = useSelector((state) => state.pCategory.jewelleryType);
  const {
    isSuccess,
    isError,
    isLoading,
    createdCategory,
    updatedCategory,
  } = useSelector((state) => state.pCategory);


  // const [img, setImg] = useState([]);
  const [img, setImg] = useState(null);
  const [pendingFile, setPendingFile] = useState(null);
  const [cropOpen, setCropOpen] = useState(false);

  useEffect(() => {
    if (isSuccess && createdCategory) {
      toast.success("Category Added Successfully!");
      navigate("/admin/list-category");
    }
    if (isSuccess && updatedCategory) {
      toast.success("Category Updated Successfully!");
      navigate("/admin/list-category");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      category_name: categoryName || "",
      category_image: categoryImage || "", // Preserve existing image
      jewellery_type: jewelleryType || "all_fine",
    },
    validationSchema: schema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("category_name", values.category_name);
      formData.append("jewellery_type", values.jewellery_type);
      // Only append a new image if the user selected one
      if (img instanceof File) {
        formData.append("category_image", img);
      } else if (categoryImage && typeof categoryImage === "string") {
        formData.append("category_image", categoryImage); // Keep existing image
      } else {
        // If no image is available, send an empty value (optional)
        formData.append("category_image", "");
      }

      if (getPCatId !== undefined) {
        const data = { id: getPCatId, pCatData: formData };
        dispatch(updateAProductCategory(data));
      } else {
        dispatch(createCategory(formData));
      }
    },
  });

  useEffect(() => {
    if (getPCatId !== undefined) {
      dispatch(getAProductCategory(getPCatId));
    } else {
      dispatch(resetState());
    }
  }, [getPCatId, dispatch]);


  return (
    <div>
      <h3 className="mb-4 title">
        {getPCatId !== undefined ? "Edit" : "Add"} Category
      </h3>
      <div>
        <form action="" onSubmit={formik.handleSubmit}>
          <div>
            <label className="form-label" htmlFor="category_name">
              Category Name <span className="text-danger">*</span>
            </label>
            <CustomInput
              type="text"
              label="Enter Product Category"
              onChng={formik.handleChange("category_name")}
              onBlr={formik.handleBlur("category_name")}
              val={formik.values.category_name}
              id="category_name"
            />
            <div className="error">
              {formik.touched.category_name && formik.errors.category_name}
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label" htmlFor="jewellery_type">
              Jewellery type <span className="text-danger">*</span>
            </label>
            <select
              id="jewellery_type"
              name="jewellery_type"
              className="form-control"
              value={formik.values.jewellery_type}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              {JEWELLERY_TYPE_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
            <div className="error">
              {formik.touched.jewellery_type && formik.errors.jewellery_type}
            </div>
          </div>

          <div>
            <label className="form-label" htmlFor="category_image">
              Category Image
            </label>

            <div className="bg-white border-1 p-5 text-center mt-1">
              <Dropzone
                onDrop={(acceptedFiles) => {
                  if (acceptedFiles.length > 0) {
                    const file = acceptedFiles[0];
                    setPendingFile(file);
                    setCropOpen(true);
                  }
                }}
                multiple={false} // Prevent multiple image selection
              >
                {({ getRootProps, getInputProps }) => (
                  <section>
                    <div {...getRootProps()}>
                      <input {...getInputProps()} />
                      <p>Drag 'n' drop some files here, or click to select files</p>
                    </div>
                  </section>
                )}
              </Dropzone>
            </div>
            <div className="showimages d-flex flex-wrap gap-3 mt-3">
              {formik.values.category_image && (
                <div className="position-relative">
                  <button
                    type="button"
                    onClick={() => {
                      setImg(""); // Clear image
                      formik.setFieldValue("category_image", ""); // Reset Formik field
                    }}
                    className="position-absolute"
                    style={{
                      right: "5px", background: "transparent",
                      border: "none",
                      color: "white",
                      fontSize: "1.5rem",
                      fontWeight: "bold",
                    }}
                  >×</button>

                  {typeof formik.values.category_image === "string" ? (
                    <img
                      src={resolveMediaUrl(formik.values.category_image)}
                      alt="category"
                      width={200}
                      height={200}
                    />
                  ) : (
                    <img
                      src={URL.createObjectURL(formik.values.category_image)}
                      alt="category"
                      width={200}
                      height={200}
                    />
                  )}
                </div>
              )}
            </div>
          </div>

          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
          >
            {getPCatId !== undefined ? "Edit" : "Add"} Category
          </button>

        </form>
      </div>
      <ImageCropperModal
        open={cropOpen}
        file={pendingFile}
        title="Crop category image"
        aspect={1}
        // Category image is square; export higher-res to avoid pixelation.
        outputWidth={1000}
        outputHeight={1000}
        onCancel={() => {
          setCropOpen(false);
          setPendingFile(null);
        }}
        onCropped={(cropped) => {
          setImg(cropped);
          formik.setFieldValue("category_image", cropped);
          setCropOpen(false);
          setPendingFile(null);
        }}
      />
    </div>
  );
};

export default Addcat;